export default "icons/spinner.svg"